module.exports = __webpack_public_path__ + "img/tablet_and_phone.4518f15f.png";